export const mapDataJsonToTable = (datajson, columns) => {
  // Map datajson to an array of objects with corresponding field names
  const data = datajson.map((item, index) => {
    const mappedItem = {};
    columns.forEach((column) => {
      mappedItem[column.field] = item[column.field] || ""; // Set default value if the field is undefined
    });
    mappedItem.id = index + 1; // Adding an 'id' field with a sequential number
    return mappedItem;
  });
  return data;
};

/**
 * this will sort an obj. array based on a given obj. key reference to a given reference array
 * @param inputArr = [{label: "Good", val: 45}, {label: "Excellent", val: 100}]
 * @param refArr = ["Excellent", "Good"]
 * @param sortParam = "label"
 * @returns [{label: "Excellent", val: 100}, {label: "Good", val: 45}]
*/
export const sortByReference = (inputArr = [], refArr = [], sortParam) => {
  inputArr.sort((a, b) => {
    const indexA = refArr.indexOf(a[sortParam]);
    const indexB = refArr.indexOf(b[sortParam]);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    } else if (indexA !== -1) {
      return -1;
    } else if (indexB !== -1) {
      return 1;
    } else {
      return 0;
    }
  });
  return inputArr;
}

/**
 * map given value to a value between 0 & 1
 * @param {*} value input value
 * @param {*} min given value's range min
 * @param {*} max given value's range max
 * @returns a value between 0 & 1
 */
export function mapValueToRange(value, min, max) {
  // Normalize the value to the range [0, 1]
  return (value - min) / (max - min);
}

/**
 * rename given obj.Array labels to given set of values
 * @param inputArr = [{label: "RSRP", val: "RSRP"}, ...]
 * @param sortParam = { RSRP: Signal Strength }
 * @returns [{label: "Signal Strength", val: "RSRP"}, ...]
*/
export const renameLabels = (inputArr = [], renameObj = {}) => {
  const data = inputArr.map(obj => {
    return {
      ...obj,
      label: obj.label in renameObj ? renameObj[obj.label] : obj.label
    }
  })
  return data;
}

export const addDynamicIcons = (inputArr = [], iconObj = {}) => {
  const data = inputArr.map(obj => {
    return {
      ...obj,
      icon: obj.value in iconObj ? iconObj[obj.value] : iconObj["default"]
    }
  })
  return data;
}